import classnames from 'classnames';
import React from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

const DefaultTabButton: React.FC<{
    domainConfiguration: DomainConfigurationDto;
    className?: string;
    label: string;
    selected?: boolean;
}> = ({ domainConfiguration, className, label, selected }) => {
    return (
        <button
            className={classnames(
                className,
                'relative py-12 z-10 border-b-2',
                selected ? '' : 'border-transparent opacity-60',
                'text-body-bold-16 lg:text-body-bold-18 text-overline-16-custom-style'
            )}
            style={
                domainConfiguration
                    ? {
                          borderColor: selected ? domainConfiguration.style.primaryColor : undefined
                      }
                    : undefined
            }>
            {label}
        </button>
    );
};

export default DefaultTabButton;
